import React from "react";
import "./Login.scss";
import Image from "../../components/image/Image";
import { AppIcons } from "../../data/appIcons";
import LoginForm from "../../features/login/Login";

const LoginPage = () => {
  return (
    <div>
      {/* <div className="row p-0 m-0">
        <div className="col-xxl-7 col-lg-7 col-md-6 col-12 p-0">
          <div className="left-bg-section">
            <Image
              imagePath={AppIcons.logoImage}
              imgCustomClassName="open-bar"
              altText="Icon"
            ></Image>
          </div>
        </div>
        <div className="col-xxl-5 col-lg-5 col-md-6 col-12 p-0">
          <div className="right-form-section">
            <LoginForm />
          </div>
        </div>
      </div> */}

      <div className="main-login-section">
        <div className="min-h-full flex items-center justify-center w-full login-wrapper">

          <div className="login-main-bg">
            <div className="">
              <Image
                imagePath={AppIcons.logoImage}
                imgCustomClassName="open-bar"
                altText="Icon"
              ></Image>

            </div>
            <div>
              <LoginForm />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LoginPage;
